import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ServiceDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

        return	<section className="service-details">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 clearfix">
                        <img src={publicUrl+"assets/images/resources/lead-generation.jpg"} alt={ imagealt } className="float-right wow fadeInLeft" data-wow-duration="1500ms" />
                    </div>{/* /.col-lg-6 */}
                    <div className="col-lg-6">
                        <div className="service-details__content">
                            <h3>Turn every conversation into  a qualified <br/>business opportunity.</h3>
                            <p>Our intelligent system transforms every interaction into a valuable business opportunity. By asking the right questions at the right time, it captures high-quality leads and instantly organizes them for your team.</p>
                            <p>From first contact to qualification, the process is fully automated, ensuring no lead is missed, and every potential customer is guided efficiently through your funnel.</p>

                        </div>{/* /.service-details__content */}
                    </div>{/* /.col-lg-6 */}
                </div>{/* /.row */}
                <div className="row">
                    <div className="col-lg-6">
                        <img src={publicUrl+"assets/images/resources/service-detail-22.jpg"} alt={ imagealt } className="wow fadeInRight" data-wow-duration="1500ms" />
                    </div>{/* /.col-lg-6 */}
                    <div className="col-lg-6">
                        <div className="service-details__content">
                            <h3>What we capture</h3>
                            <ul className="list-unstyled service-details__list">
                                <li>
                                    Name & contact details
                                </li>
                                <li>Service/product interest</li>
                                <li>Budget & requirements</li>
                                <li>User preferences</li>
                                <li>Time of inquiry</li>
                            </ul>{/* /.list-unstyled service-details__list */}
                        </div>{/* /.service-details__content */}
                    </div>{/* /.col-lg-6 */}
                </div>{/* /.row */}
                <div className="row">
                    <div className="col-lg-6 clearfix">
                        <img src={publicUrl+"assets/images/resources/smart-data.jpg"} alt={ imagealt } className="float-right wow fadeInLeft" data-wow-duration="1500ms" />
                    </div>{/* /.col-lg-6 */}
                    <div className="col-lg-6">
                        <div className="service-details__content">
                            <h3>Smart Data Capture & Real-Time Insights</h3>
                            <p className="mb-3">All collected data is structured and delivered directly to your dashboard or CRM, enabling faster decision-making and better follow-ups.</p>

                            <h4 className="mb-4">Additional Capabilities</h4>
                            <ul className="list-unstyled service-details__list">
                                <li>
                                    Real-time lead notifications
                                </li>
                                <li>Lead scoring & prioritization
                                </li>
                                <li>Conversation history tracking
                                </li>
                                <li>CRM integration (e.g., HubSpot)</li>
                                <li>Automated follow-up triggers</li>
                            </ul>{/* /.list-unstyled service-details__list */}
                        </div>{/* /.service-details__content */}
                    </div>{/* /.col-lg-6 */}
                </div>{/* /.row */}
            </div>{/* /.container */}
        </section>

    }
}

export default ServiceDetails